module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__box-subtitle01-d91aae9dbd11e9fac6521ddd589c30d1.png";